import { useMemo } from 'react'
import { FooterFragment, useFooterQuery } from '../../graphql'

function useFooterContent(): Array<FooterFragment | null | undefined> | null | undefined {
  const { loading, data } = useFooterQuery()
  return useMemo(() => (!loading && data?.footers ? data.footers : []), [loading, data])
}
export { useFooterContent }
